import Model from "./abstract/Model";

export default class ApiToken extends Model {
  constructor(props) {
    super();
    this.initializeAttributes(props);
  }
}
